module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dF4e2"))).then(() => parcelRequire('fThBo'));